// ─────────────────────────────────────────────────────────────────────────────
// ChartTooltip.js — the hover card both charts on this page use.
//
// LineChart and BarChart had byte-identical tooltip markup before; it lives here
// so the two can't drift apart. Positioning is the caller's job (the line chart
// anchors to a point, the bar chart to the top of a bar), so it takes className
// and style through.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./ChartTooltip.module.css";

/**
 * @param {object} props
 * @param {string} props.title           the big left-hand line (a day, a region)
 * @param {string} [props.sub]           optional second line under it
 * @param {string} props.label           caption above the value badge
 * @param {ReactNode} props.value        the badge contents
 * @param {string} [props.className]     extra positioning class
 * @param {object} [props.style]         inline position (left/top/bottom)
 */
export default function ChartTooltip({ title, sub, label, value, className = "", style }) {
  return (
    <div className={`${styles.tooltip} ${className}`} style={style}>
      <div className={styles.dayCol}>
        <div className={styles.date}>{title}</div>
        {sub && <div className={styles.sub}>{sub}</div>}
      </div>
      <div className={styles.badgeCol}>
        <div className={styles.badgeLabel}>{label}</div>
        <div className={styles.badge}><strong>{value}</strong></div>
      </div>
    </div>
  );
}
